/**
 * Placeholder for removed local agent-ingest debug logging.
 * Keeps call sites stable; does not perform network I/O.
 */
export function debugSessionLog(_payload) {
    /* intentionally empty */
}
